import { useSettingsPanelContext } from 'providers/SettingsPanelProvider';
import { useEffect } from 'react';
import Banner from './common/Banner/Banner';
import BookDemo from './common/BookDemo/BookDemo';
import Header from './common/Header/Header';
import StartToday from './default/StartToday/StartToday';
import Testimonials from './default/Testimonials/Testimonials';
import WhoCrudBeat from './default/WhoCrudBeat.tsx/WhoCrudBeat';
import Footer from './common/Footer/Footer';
import ContactUs from './default/ContactUs/ContactUs';

function Main() {
  const { setSettingsPanelConfig } = useSettingsPanelContext();

  useEffect(() => {
    setSettingsPanelConfig({ showSettingPanelButton: false });
  }, []);

  return (
    <main>
      <Header role="default" />
      <Banner role="default" />
      <WhoCrudBeat />
      <BookDemo role="default" />
      <Testimonials />
      <StartToday />
      <ContactUs />
      <Footer />
    </main>
  );
}

export default Main;
